import './App.css';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Container from "./Container/Container";
import Home from "./Component/Home/Home";
import Laboratory from "./Component/Laboratory/Laboratory";
import Portfolio from "./Component/Portfolio/Portfolio";
import Team from "./Component/Team/Team";
import Contact from "./Component/Contact/Contact";
import Studio from "./Component/Studio/Studio";
import NotFound from "./Component/NotFound/NotFound";


function App() {

    return (
        <div className="App">
            <Router>
                <Routes>
                    <Route path="/" element={<Container/>}>
                        <Route index element={<Home/>}/>
                        <Route path="/laboratory" element={<Laboratory/>}/>
                        <Route path="/portfolio" element={<Portfolio/>}/>
                        <Route path="/team" element={<Team/>}/>
                        <Route path="/contact" element={<Contact/>}/>
                        <Route path="/studio" element={<Studio/>}/>
                        <Route path="/*" element={<NotFound/>}/>
                    </Route>
                </Routes>
            </Router>
        </div>
    );
}


export default App;
